import { A11yModule } from '@angular/cdk/a11y';
import { NgModule } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  heroArrowRightStartOnRectangle,
  heroBars3,
  heroBell,
  heroChatBubbleOvalLeft,
  heroChevronRight,
  heroCog6Tooth,
  heroEllipsisVertical,
  heroInformationCircle,
  heroMinus,
  heroPlus,
  heroUserCircle,
  heroXMark,
} from '@ng-icons/heroicons/outline';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { DashboardLayoutComponent } from './dashboard-layout/dashboard-layout.component';
import { DashboardHeaderComponent } from './components/dashboard-header/dashboard-header.component';
import { MenuComponent } from './components/menu/menu.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    AuthLayoutComponent,
    DashboardLayoutComponent,
    DashboardHeaderComponent,
    MenuComponent,
  ],
  imports: [A11yModule, SharedModule, NgIcon],
  providers: [
    provideIcons({
      heroArrowRightStartOnRectangle,
      heroBars3,
      heroBell,
      heroChatBubbleOvalLeft,
      heroChevronRight,
      heroCog6Tooth,
      heroEllipsisVertical,
      heroInformationCircle,
      heroMinus,
      heroPlus,
      heroUserCircle,
      heroXMark,
    }),
  ],
  exports: [AuthLayoutComponent, DashboardLayoutComponent, DashboardHeaderComponent, MenuComponent],
})
export class LayoutModule {}
